<template>
  <div class="g-box empty-banner">
    <i class="iconfont iconwenjian icon"></i>
    <div class="g-font-mid label">{{ label }}</div>
  </div>
</template>

<script>

export default {
  name: 'EmptyBanner',
  props: {
    label: {
      type: String,
      require: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .empty-banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 198px;
    color: var(--color-des);
  }

  .icon {
    font-size: 36px;
  }

  .label {
    margin-top: 26px;
    line-height: 20px;
    font-size: 16px;
  }
</style>
